import React from 'react'

import BacteriaRecordDialog from '../BacteriaRecordDialog'
import MineralRecordDialog from '../MineralRecordDialog'
import WaterQualityDialog from '../WaterQualityDialog'

interface Option {
  id: number
  label: string
}

interface RecordQualityDialogProps {
  open: boolean
  onClose: () => void
  selectedOption: Option | null
}

const RecordQualityOption: React.FC<RecordQualityDialogProps> = ({
  open,
  onClose,
  selectedOption,
}) => {
  if (!selectedOption) {
    return null
  }

  const isQualityReport = selectedOption.id === 1
  const isMineralReport = selectedOption.id === 2
  const isBacteriaReport = selectedOption.id === 3

  if (isQualityReport) {
    return <WaterQualityDialog open={open} onClose={onClose} />
  }

  if (isMineralReport) {
    return <MineralRecordDialog open={open} onClose={onClose} />
  }

  if (isBacteriaReport) {
    return <BacteriaRecordDialog open={open} onClose={onClose} />
  }
  return null
}

export default RecordQualityOption
